import React from 'react';
import styles from './register.module.css';
import axios from 'axios'
import Paper from '@material-ui/core/Paper'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import {withRouter} from 'react-router-dom'
import Snackbar from '../../utils/snackbar/Snackbar';
import {setUser} from '../../../containers/app/actions'
import {connect} from 'react-redux';

const Register = (props) => {
    const [formData,setFormData] = React.useState({
        email: "",
        password: "",
        userName: "",
        userType: "Admin",
        contactNum: "",
        userAddress: ""
    });
    const [err,setErr] = React.useState({
        email: false,
        password: false,
        userName: false,
        contactNum: false,
        userAddress: false
    })
    const [loading,setLoading] = React.useState(false)
    const [alert,setAlert] = React.useState(false);
    

    React.useEffect(() => {
        if(props.user) {
            props.history.push("/admin/dashboard")
        }
    },[props.user])

    const validate = () => { 
        let valid = true;
        let error = {email: false,password: false,userName: false, contactNum: false,userAddress: false};
        Object.keys(formData).map(key => {
            if(formData[key] == "") { 
                error[key] = `* ${key} field cannot be empty`;
                valid = false;
            }
        });
        setErr({...error})
        return valid;
    } 

    const onSubmit = () => {
        if(validate()) {
            setLoading(true);
            axios({
                method: "post",
                url: "/signUserApi",
                nonAuth: true,
                data: {
                    ...formData
                }
            }).then(res => {
                if(res.data.success) {
                    setAlert("Register Successfully");
                    localStorage.setItem("user",JSON.stringify(res.data.data.contactNum))
                    props.setUser(res.data.data)
                    props.history.push("/admin/dashboard")
                } else { 
                    setAlert(res.data.msg)
                }
                setLoading(false); 
            }).catch(err => {
                setLoading(false); 
            })
        }
    }
    return (
        <div className={styles.container}>
            <Snackbar open={alert} onClose={() => setAlert(false)} />
            <div className={styles.content}>
                <Paper className={styles.paper} elevation={3}>
                    <h1>Register</h1>

                    <TextField 
                        value={formData.userName}
                        label="Enter UserName"
                        type="text"
                        onChange={(e) => setFormData({...formData,userName: e.target.value})}
                        helperText={err.userName}
                        error={err.userName}
                        className={styles.textField}
                        fullWidth
                    />


                    <TextField 
                        value={formData.email}
                        label="Enter Email"
                        type="email"
                        onChange={(e) => setFormData({...formData,email: e.target.value})}
                        helperText={err.email}
                        error={err.email}
                        className={styles.textField}
                        fullWidth
                    />

                    <TextField 
                        value={formData.contactNum}
                        label="Enter Contact"
                        type="number"
                        onChange={(e) => setFormData({...formData,contactNum: e.target.value})}
                        helperText={err.contactNum}
                        error={err.contactNum}
                        className={styles.textField}
                        fullWidth
                    />

                    <TextField  
                        value={formData.userAddress}
                        label="Enter Address"
                        type="text"
                        onChange={(e) => setFormData({...formData,userAddress: e.target.value})}
                        helperText={err.userAddress}
                        error={err.userAddress}
                        className={styles.textField}
                        fullWidth
                    />


                    <TextField 
                        value={formData.password}
                        type="password"
                        label="Enter Password"
                        onChange={(e) => setFormData({...formData,password: e.target.value})}
                        helperText={err.password}
                        error={err.password}
                        className={styles.textField}
                        fullWidth
                    />

                    <div className={styles.contentSpace}>
                        <Button color="primary" onClick={() => props.history.push("/login")}>Login Here</Button>
                        {loading 
                            ?
                        <Button variant="contained" color="primary">Loading...</Button>
                            :
                        <Button variant="contained" color="primary" onClick={onSubmit}>Register</Button>}
                    </div>
                </Paper>
            </div>         
        </div>
    )
}
const mapStateToProps = state => ({
    user: state.appReducer.user
});
export default withRouter(connect(mapStateToProps,{setUser})(Register));